import Select from '@betterfunnel/ui-core/Select';
import { Form } from '@betterfunnel/types';
import { QueryDocumentSnapshot } from 'firebase/firestore';
import { useDashboardContext } from '../../contexts/DashboardContext';

interface Props {
  title?: string;
  selected?: string;
  onChange?: (form: QueryDocumentSnapshot<Form> | null) => void;
  formOptions?: QueryDocumentSnapshot<Form, Form>[] | null;
}

export const FormSelector = ({
  title,
  selected,
  onChange,
  formOptions,
}: Props) => {
  const { forms: allForms } = useDashboardContext();

  const options = formOptions ?? allForms ?? null;
  const selectedForm = options?.find((f) => f.id === selected);

  return (
    <Select<QueryDocumentSnapshot<Form, Form>>
      title={title}
      selected={selectedForm}
      onChange={(e) => {
        onChange?.(e);
      }}
      loading={options === null}
      options={
        options?.map((form) => ({
          key: form.id,
          value: form,
          child: form.data().name,
        })) || []
      }
    />
  );
};
